export default function About() {
    return (
        <div data-testid="about-page" className="pt-32 pb-24 mx-auto max-w-[900px] px-6 lg:px-10">
            <span className="text-[11px] uppercase tracking-[0.2em] font-bold text-[#FFD400]">About Us</span>
            <h1 className="mt-2 font-display text-5xl sm:text-6xl font-black tracking-tight">
                India's AI entertainment studio.
            </h1>
            <p className="mt-6 text-lg text-white/70 leading-relaxed">
                Apni Dukan is a next-generation entertainment platform where every story, every character, and every cinematic frame is crafted with generative AI. From web series like <span className="text-white font-semibold">BLACKLIST</span> to viral shorts and premium AI commercials — we build content that couldn't exist a year ago.
            </p>
            <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6">
                {[
                    { k: "400+", v: "AI Projects Delivered" },
                    { k: "100K+", v: "Community Strong" },
                    { k: "9", v: "Creative Categories" },
                ].map((x) => (
                    <div key={x.k} className="rounded-[18px] border border-white/10 bg-white/[0.02] p-6">
                        <div className="font-display font-black text-4xl text-[#FFD400]">{x.k}</div>
                        <div className="text-sm text-white/60 mt-1">{x.v}</div>
                    </div>
                ))}
            </div>
            <h2 className="mt-16 font-display font-bold text-3xl">What we stand for</h2>
            <p className="mt-4 text-white/70 leading-relaxed">
                Cinematic quality. Ruthless storytelling. Zero shortcuts on craft — even when the pipeline is built entirely on models. If it wouldn't hold up on a streaming service, it doesn't leave the studio.
            </p>
        </div>
    );
}
